import { useUI } from '@components/ui'
import { openLoginView } from '@framework/utils/app-util'
import { useRouter } from 'next/router'

interface ILoggedOutSection {
  screen: string
}

const LoggedOutSection = (props: ILoggedOutSection) => {
  const { screen } = props
  const { setSidebarView } = useUI()

  const router = useRouter()

  return (
    <section className="relative col-span-9 tabpanel-sm mob-tab-full mt-2">
      <div className="w-full profile-container">
        <div className="px-6 sm:px-6 lg:px-8">
          <h2 className="max-w-4xl mx-auto mt-6 text-base font-semibold sm:text-xl text-primary">
            Login to view {screen}
          </h2>
          <div className="flex sm:flex-col1 py-5">
            <button
              className="w-full flex btn-basic-property items-center justify-center px-4 btn-basic-property -mr-0.5 text-white bg-black border-2 border-black rounded-sm hover:bg-gray-800 hover:text-whitesm:px-6 hover:border-gray-900"
              onClick={() => {
                openLoginView(router?.asPath)
                setSidebarView('LOGIN_VIEW')
              }}
            >
              <span className="inline-block font-16">Login Now</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LoggedOutSection
